import React from 'react';
import {
  ACCESS_CPANEL_ARTICLE, ADD_DOMAIN_TO_HOST_ARTICLE, CLIENT_AREA_FEATURES_ARTICLE, CONFIGURE_DOMAIN_DNS_ARTICLE, CREATE_WORDPRESS_SITE_ARTICLE,
} from '@/config/urls/supportUrls';

export default {
  diagnostic: {
    helpLinks: [
      {
        title: 'Guía inicial de su Hospedaje ',
        link: CLIENT_AREA_FEATURES_ARTICLE,
      },
      {
        title: 'Cómo configurar el dominio (Cambiar DNS)',
        link: CONFIGURE_DOMAIN_DNS_ARTICLE,
      },
      {
        title: 'Cómo agregar un dominio en el hosting',
        link: ADD_DOMAIN_TO_HOST_ARTICLE,
      },
      {
        title: 'Cómo crear un sitio web en WordPress a través del Portal del Cliente',
        link: CREATE_WORDPRESS_SITE_ARTICLE,
      },
      {
        title: 'Cómo acceder al cPanel',
        link: ACCESS_CPANEL_ARTICLE,
      },
    ],
  },
  zopimDepartments: {
    builder: 'hges_chat_constructor_de_sitios',
    domain: 'hges_chat_dominios',
    financial: 'hges_chat_financeiro',
    mail: 'hges_chat_email',
    priority: 'priority',
    retention: 'hges_chat_retencao',
    shared: 'hges_chat_compartilhado',
    skilled: 'specialized',
    tos: 'hges_chat_abuse_tos',
  },
  resetMessages: ['Por ahora esta conversación sera finalizada, pero siempre estamos aquí si necesitas algo más. Pronto recibirás un correo electrónico con el historial de nuestra conversación'],
  chatFinished: 'Esta conversación ha sido finalizada. Si aún necesitas ayuda, simplemente inicia una nueva conversación.',
  startNewChat: 'Iniciar nueva atención',
  chatbot: {
    title: (
      <>
        <strong>Hola, soy Cortex,</strong>
        <br />
        tu especialista virtual.
      </>
    ),
    description: (
      <>
        Estoy
        {' '}
        <strong>disponible 24h,</strong>
        {' '}
        y puedo ayudarte con:
      </>
    ),
    cards: [
      {
        id: 1,
        cardText: (
          <>
            Dudas sobre suscripciones y
            <br />
            los productos de HostGator.
          </>
        ),
      },
      {
        id: 2,
        cardText: (
          <>
            Resolución de problemas en tu
            <br />
            hospedaje, sitios y correos electrónicos.
          </>
        ),
      },
      {
        id: 3,
        cardText: (
          <>
            Asistencia con configuraciones
            <br />
            y estado de tus sitios.
          </>
        ),
      },
    ],
    startChat: 'Iniciar conversación',
    aiAlert: 'Los contenidos generados por inteligencia artificial pueden contener errores o ser imprecisos.',
    inputPlaceholder: 'Ingresa aquí tu duda',
    welcomeMessage: 'Hola, 👋 Soy el especialista virtual de HostGator y estoy aquí para asistirte.',
    closeChat: '¿Deseas finalizar el chat?',
    closeChatAlert: 'Una vez finalizado, el historial de esta conversación será eliminado.',
    cancel: 'Cancelar',
    finishChat: 'Finalizar chat',
    resetChat: 'Reiniciar chat',
    finishChatTooltip: 'Cerrar chat',
    errorMessage: 'Algo salió mal y no fue posible procesar tu solicitud. ¿Qué tal intentar de nuevo?',
    errorMessageAgain: 'Ops, parece que el error continúa. Puedes intentar de nuevo o hablar con un agente.',
    tryAgain: 'Intentar de nuevo',
    talkWithHuman: 'Hablar con un agente',
    transferToHuman: 'Ok, te transferiré a un agente para que pueda ayudarte, espera un momento...',
    notHelpedMe: 'La respuesta no me ayudó',
    helpedMe: 'La respuesta me ayudó',
    stopMessage: 'Detener respuesta del Cortex',
  },
};
